import { useTranslation } from '@fluentsms/i18n';

export const TaxIdMasks = () => {
  const { t } = useTranslation('common');

  return {
    EIN: {
      label: `${t('taxIdFieldGroup.typeLabel.EIN')}`,
      mask: '**-*******',
    },
    SSN: {
      label: `${t('taxIdFieldGroup.typeLabel.SSN')}`,
      mask: '***-**-****',
    },
    ITIN: {
      label: `${t('taxIdFieldGroup.typeLabel.ITIN')}`,
      mask: '***-**-****',
    },
    Unknown: {
      label: `${t('taxIdFieldGroup.typeLabel.Unknown')}`,
      mask: '*********',
    },
  };
};

export const TaxIdMasksWithRAC = () => {
  const { t } = useTranslation('common');

  return {
    ...TaxIdMasks(),
    RAC: {
      label: `${t('taxIdFieldGroup.typeLabel.RAC')}`,
      mask: '***********',
    },
  };
};
